import apiConfig from './api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const signin = async (credentials) => {
  const { username, password } = credentials;
  if (!username) {
    throw new Error('Email is required');
  }

  if (!password) {
    throw new Error('Password is required');
  }

  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/users/signin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to sign up');
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};

export const signup = async (userData, uuid, token) => {
  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/users/signup/${uuid}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({userData, token}),
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to sign up');
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};

export const verify2faCode = async (userId, code) => {
  const token = sessionStorage.getItem('authToken2fa');
  if (!token) {
    throw new Error('No 2fa token found');
  }

  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/users/${userId}/verify2fa`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ code }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to verify 2FA');
    }
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/users/reset`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to send reset email');
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (userId, password, token = null) => {
  if (!token) {
    throw new Error('No 2fa token found');
  }

  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/update/${userId}/reset-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ password, token }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to reset password');
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};

export const signout = async (userId) => {
  const token = sessionStorage.getItem('authToken');
  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/users/${userId}/signout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to sign out');
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};
